export const MenuList = [
    //Dashboard
    
    {   
        title:'Dashboard',
        iconStyle: <i className="flaticon-381-home-2"></i>,
        to: '/dashboard',
    },

    // Staff Management
    {   
        title:'Staff',
        iconStyle: <i className="flaticon-381-user-1"></i>,
        to: '/staff-list',
    },

    // User Management
    {   
        title:'Users',
        iconStyle: <i className="flaticon-381-user-7"></i>,
        to: '/user-list',
    },

    // OrgTicket 
    {   
        title:'Org Tickets',
        iconStyle: <i className="flaticon-381-id-card-3"></i>,
        to: '/list-org-tickets',
    },

    // Event Management
    {   
        title:'Events',
        iconStyle: <i className="flaticon-381-calendar-1"></i>,
        to: '/events-list',
    },


    // Transaction Pages

    {
        title: 'Transaction',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-list-1"></i>,
        content: [
            // {
            //     title: 'Transaction',
            //     to: '/transaction',					
            // },
            {
                title: 'Primary Market',
                to: '/primary-market-transaction',					
            },
            {
                title: 'Secondary Market',
                to: '/secondary-market-transaction',					
            },
            {
                title: 'Organizer',
                to: '/organizers-transaction',					
            }
        ]
    },

    {
        title:'Resale Market',
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-repeat-1"></i>,
        content : [            
            {
                title:'Listed Tickets',
                to: '/listed-tickets',
            },
            {
                title:'Sold Tickets',
                to: '/sold-tickets',
            },
        ]   
    }, 
    
    {   
        title:'Analytics',
        iconStyle: <i className="flaticon-381-presentation"></i>,
        to: '/analytics',
    },
]